import Swiper from 'swiper'
import { Navigation, Scrollbar } from 'swiper/modules'

const swiperCarousel = document.querySelectorAll('.swiper-carousel')

function initSwiperCarousel() {
    if (!swiperCarousel.length) return

    swiperCarousel.forEach((swiperWrapper) => {
        const cols = Number(swiperWrapper.dataset.slider_cols)

        // Bas-breakpoints
        const breakpoints = {
            0: {
                slidesPerView: 2,
                spaceBetween: 8,
            },
            576: {
                slidesPerView: 2.8,
                spaceBetween: 8,
            },
            768: {
                slidesPerView: 3.6,
                spaceBetween: 8,
            },
            1280: {
                slidesPerView: cols,
                spaceBetween: 8,
            },
        }

        // Lägg till extra breakpoint om > 4
        if (cols >= 4) {
            breakpoints[1024] = {
                slidesPerView: 4.1,
                spaceBetween: 8,
            }
        }

        const swiper = new Swiper(swiperWrapper, {
            modules: [Navigation, Scrollbar],
            breakpoints,
            navigation: {
                nextEl: swiperWrapper.parentElement.querySelector('.swiper-button-next'),
                prevEl: swiperWrapper.parentElement.querySelector('.swiper-button-prev'),
            },
            scrollbar: {
                el: swiperWrapper.parentElement.querySelector('.swiper-scrollbar'),
                draggable: true,
            },
            speed: 500,
        })

        swiperWrapper.swiper = swiper
    })
}

initSwiperCarousel()
